;(function () {
  'use strict'
  angular
    .module('contrast.tsv')
    .controller('TsvVerificationCtrl', TsvVerificationCtrl)

  function TsvVerificationCtrl(
    $scope,
    $location,
    $translate,
    permissions,
    AuthService,
    logoutService,
    UserService,
    ProfileService,
    ErrorService,
    CommonFactory,
    tsvApiConfig,
    Fingerprint2
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        submitting: false,
        username: ProfileService.getName(),
        trusted: false,
        show_breadcrumbs: false,
        error: false
      }
    })

    angular.extend($scope, {
      submit: submit,
      logout: logout
    })

    function init() {
      _getInformation()
      if (AuthService.getInitializeTsv()) {
        _initializeTsv()
      }
    }

    function submit() {
      $scope.submitting = true

      if ($scope.model.trusted) {
        new Fingerprint2().get(function (result) {
          tsvApiConfig
            .authorizeCode({ code: $scope.model.code, fingerprint: result })
            .then(_handleAuthorizeSuccess, _handleAuthorizeError)
        })
      } else {
        tsvApiConfig
          .authorizeCode({ code: $scope.model.code })
          .then(_handleAuthorizeSuccess, _handleAuthorizeError)
      }
    }

    function _handleAuthorizeSuccess(_response) {
      permissions.getDefaultOrganization().then(function () {
        $location.path(UserService.buildUrl('/dashboard'), true)
      })
    }

    function _handleAuthorizeError(response) {
      $scope.submitting = false
      if (response.status == 423) {
        logoutService.logout({
          redirectToSignin: true,
          redirectParams: { failedMaxTsvAttempts: true }
        })
      } else {
        ErrorService.processError(response)
      }
    }

    function logout() {
      logoutService.logout({ redirectToSignin: true })
    }

    function _getInformation() {
      CommonFactory.getInformation().then(
        function (response) {
          $scope.model.show_breadcrumbs = response.data.tsv_breadcrumbs
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _initializeTsv() {
      var transl = {
        detail_tsvVerificationCode_problemInitializingProcess:
          $translate.instant(
            'detail_tsvVerificationCode_problemInitializingProcess'
          )
      }

      AuthService.setInitializeTsv(true)
      tsvApiConfig.initialize().then(
        function (response) {
          ProfileService.setTsvType(response.data.type)
        },
        function () {
          $scope.model.error =
            transl.detail_tsvVerificationCode_problemInitializingProcess
        }
      )
    }

    init()
  }
})()
